import React from 'react';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import DepositForm from './depositForm';
import { getPublicRental } from "../../../data/loca/rentals";
import { stripeCall, publishableKey } from "../../../data/loca/stripe";
import { calendarStrings } from '../../../services/calendarStrings';

import {
    useLoaderData
} from "react-router-dom";

import Moment from 'react-moment';
import 'moment/locale/fr';
export async function loader({ params }) {

    const rental = await getPublicRental(params.rentalId);

    let resp = await stripeCall(params.rentalId);
    var error = resp.error;
    
    var ClientSecret = resp.clientSecret;
    var Status = resp.status;

    let Key = await publishableKey();
    var key = Key.key;
    return { ClientSecret, Status, key, rental,  error };
}

export default function StripeDeposit() {
    const { ClientSecret, Status, key, rental, error } = useLoaderData();

    const stripePromise = loadStripe(key);
   
    const options = {
        clientSecret: ClientSecret
    };

    return (
        <div className="financialForm">

            <div id="thumbnail">


                <div>
                    {Status === "Error" ? (
                        <h3>
                            {error}
                        </h3>
                    )
                        : (
                        <>
                            <img className="depositImg" height="192" key={rental.publicId} alt={rental.name} src={rental.base64Picture || null} />

                    <h1>Location : {rental.name}</h1>

                  
                    <div id="thumbnail-form">
                        <label>Par :&nbsp;<b>{rental.clientFirstname} {rental.clientLastname}</b></label> ({rental.serviceName})
                        
                    </div>
                    <label>
                    Date :&nbsp;
                        <Moment locale="fr" calendar={calendarStrings}>
                            {new Date(rental.startDate)}
                        </Moment>
                        &nbsp;jusqu'&agrave;&nbsp;
                        <Moment locale="fr" calendar={calendarStrings}>
                            {new Date(rental.endDate)}
                        </Moment>

                    </label>

                   
                        
                    <div className="contentForm"></div>
                    

                    {Status === "Created" ? (
                        <>
                            <h2>Dépôt de garantie</h2>
                            <p>Montant <b>non encaissé</b> : {rental.deposit / 100}€</p>
                            <Elements stripe={stripePromise} options={options}>
                                <DepositForm />
                            </Elements>
                        </>
                    ) 
                        : (
                            <>
                                <h2>Caution déposée avec succès !</h2>
                            </>
                        )}

                            </>
                        )}
                </div>

            </div>
                
        </div>
    )            
}
